<template>
  <div>
    <h2 class="color-h2-project font-weight-bold">Ubicación</h2>
    <p>{{address}}</p>
    <div id="map-container-location" class="mt-2">
      <iframe
        id="iframe_map"
        class="map_project"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        width="100%"
        :src="src_map"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationSection",
  props: {
    src_map: {
      type: String,
      default: ""
    },
    address: ''
  },
};
</script>

<style scoped>
.map_project {
  width: 100%;
  height: 320px;
  z-index: 199;
  border-radius: 16px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}

@media (max-width: 960px) {
  .map_project {
    height: 24rem;
    border-radius: 16px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  }
}

@media (max-width: 512px) {
  .map_project {
    height: 12rem;
    border-radius: 16px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  }
}
</style>
